import { render, staticRenderFns } from "./FuturVoisin.vue?vue&type=template&id=5c7c493d&scoped=true&"
import script from "./FuturVoisin.vue?vue&type=script&lang=ts&"
export * from "./FuturVoisin.vue?vue&type=script&lang=ts&"
import style0 from "./FuturVoisin.vue?vue&type=style&index=0&id=5c7c493d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c493d",
  null
  
)

export default component.exports